import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// Alguns links de landing page/tracking (FullStory, GTM, etc.) podem gerar
// parâmetros malformados na URL, como uma chave vazia (ex: "?a=1&=undefined").
// Isso quebra o Vue ao tentar aplicar um atributo com nome inválido no DOM,
// então removemos chaves inválidas antes de repassar a query como props.
function queryToProps(route: { query: Record<string, unknown> }) {
  const props: Record<string, unknown> = {};
  Object.keys(route.query).forEach((key) => {
    if (key) {
      props[key] = route.query[key];
    }
  });
  return props;
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dados',
      props: queryToProps,
      meta: { title: 'Home', backButton: false },
      component: () => import(/* webpackChunkName: "dados" */ '@/views/Dados.vue'),
    },
    {
      path: '/simule',
      name: 'cliente',
      props: queryToProps,
      meta: { title: 'Home', backButton: false },
      component: () => import(/* webpackChunkName: "cliente" */ '@/views/DadosCliente.vue'),
    },
    {
      path: '/veiculo',
      name: 'veiculo',
      meta: { title: 'Veículo' },
      component: () => import(/* webpackChunkName: "veiculo" */ '@/views/DadosVeiculo.vue'),
    },
    {
      path: '/detalhes/:arg',
      name: 'detalhes',
      meta: { title: 'Proposta' },
      component: () => import(/* webpackChunkName: "detalhes" */ '@/views/Detalhes.vue'),
    },
    {
      path: '/resumo/:arg',
      name: 'resumo',
      meta: { title: 'Resumo' },
      component: () => import(/* webpackChunkName: "resumo" */ '@/views/Resumo.vue'),
    },
    {
      path: '/proposta',
      name: 'proposta',
      props: queryToProps,
      meta: { title: 'Proposta', backButton: false  },
      component: () => import(/* webpackChunkName: "proposta" */ '@/views/Proposta.vue'),
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
